import type { ViewModel } from '../Models/ViewModel';

export function hasRouteParameters(routePath?: string): boolean {
	return routePath?.split('/').some((segment) => segment.startsWith(':')) ?? false;
}

export function getInitialDesignerView(views: ViewModel[], preferredId?: string): ViewModel | null {
	const preferred = views.find((view) => view.Id === preferredId);
	if (preferred && !hasRouteParameters(preferred.RoutePath)) {
		return preferred;
	}

	const candidates = views.filter((view) => !view.Dialog && !hasRouteParameters(view.RoutePath));
	// Prefer the closest listing ancestor of a remembered detail route.
	const ancestors = preferred?.RoutePath
		? candidates.filter((view) => view.RoutePath && view.RoutePath !== '/' && preferred.RoutePath!.startsWith(`${view.RoutePath.replace(/\/$/, '')}/`))
		: [];
	ancestors.sort((left, right) => right.RoutePath!.length - left.RoutePath!.length);
	return ancestors[0] ?? candidates.find((view) => view.RoutePath === '/') ?? candidates.find((view) => !!view.RoutePath) ?? candidates[0] ?? null;
}
